module.exports = __webpack_public_path__ + "img/z轴.fa8c2a0a.jpg";